var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLedger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.8061 4H11.5952V16.3448H23.957V7.21186C23.962 5.47776 22.5426 4 20.8061 4ZM8.76652 4H7.2213C5.48482 4 4 5.41242 4 7.21689V8.75999H8.76652V4ZM4 11.6502H8.76652V16.4102H4V11.6502ZM19.1955 23.995H20.7407C22.4772 23.995 23.962 22.5826 23.962 20.7781V19.24H19.1955V23.995ZM11.5952 19.24H16.3617V24H11.5952V19.24ZM4 19.24V20.7831C4 22.5172 5.41435 24 7.2213 24H8.76652V19.24H4Z",
    fill: "black"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLedger);
export default __webpack_public_path__ + "static/media/Ledger.b04e5722c523f76b090face4d725e743.svg";
export { ForwardRef as ReactComponent };